export default function Circle(props) {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' {...props}>
      <circle cx='7' cy='7' r='7' />
    </svg>
  )
}
